import "./css/buscarCampania.css";
import React, { useContext, useEffect, useState } from "react";
import { getCampaigns, getCampaignsByClient, getClientId } from "../api";
import UiUtils from "../../utils/UiUtils";
import ApiClient from "../../utils/ApiClient";
import { Box, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import DashboardNav from "../dashboard/components/navbar/Navbar";
import "./css/formCampaña.css";
import AddParameters from "../Parametros/AddParameters";
import CampaingItem from "../../components/campaing-items/CampaingItem";
import { CampContext } from "../../context/CampContext";
import Form from "./Form";
import Loader from "react-block-ui/lib/Loader";
import { UserContext } from "../../context/UserContext";
import { Button } from "react-bootstrap";

const useStyles = makeStyles((theme) => ({
    paper: {
        boxSizing: "border-box",
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
    },
    formControl: {
        width: "100%",
    },
    textField: {
        width: "100%",
        marginLeft: theme.spacing(3),
    },
    textFieldR: {
        marginTop: theme.spacing(2),
        width: "80%",
        marginLeft: theme.spacing(3),
        color: "black",
    },
    root: {
        ...theme.typography.button,
        backgroundColor: theme.palette.background.paper,
    },
    container: {
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom:"4rem"
    },
    loader: {
        width: "100%",
        height: "300px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    alert: {
        width: "100%",
        height: "300px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
    },
}));

const SearchCampaing = ({
    filterQuery,
    setFilterQuery,
    campanias,
    error,
    loading,
}) => {
    const classes = useStyles();

    return (
        <div>
            <Grid
                item
                xs={11}
                sm={10}
                md={8}
                lg={6}
                xl={5}
                className={classes.container}
            >
                <div id="filterField">
                    <TextField
                        margin="normal"
                        value={filterQuery}
                        placeholder="Buscar por Nombre o Hash"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => setFilterQuery(e.target.value)}
                    />
                </div>

                {loading && !error && (
                    <div className={classes.loader}>
                        <div>Cargando</div>
                        <Loader />
                    </div>
                )}

                <Box>
                    {campanias.length
                        ? campanias.map((camp) => (
                              <CampaingItem
                                  key={camp.hash}
                                  campania={camp}
                                  parent="search"
                              />
                          ))
                        : null}
                </Box>
            </Grid>
        </div>
    );
};

const BuscarCampaña = (props) => {
    const classes = useStyles();

    const { state } = useContext(CampContext);
    const { user, setUser, campanias, setCampanias } = useContext(UserContext);

    const [fiteredCamps, setFiteredCamps] = useState(null);

    const [error, setError] = useState("");

    const [filterQuery, setFilterQuery] = useState("");
    const [loading, setLoading] = useState(false);

    const filtrarCampsQuery = (query) => {
        if (query !== "") {
            const queryToLower = query.toLowerCase();
            const filtradas = campanias.filter((camp) => {
                return (
                    camp.hash.toLowerCase().includes(queryToLower) ||
                    camp.nombre.toLowerCase().includes(queryToLower)
                );
            });
            setFiteredCamps(filtradas);
        } else {
            setFiteredCamps(null);
        }
    };

    //trae todas las campanias
    async function getCampaignByClientIdFunc(id) {
        try {
            setLoading(true);
            const res = await getCampaignsByClient(id);
            setCampanias(res.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setError("Hubo un error");
        }
    }

    function getData() {
        getClientId()
        .then(res=>{
          setUser({idCliente:res.data})
        })
        .catch(err=>{
          setError(err)
          UiUtils.showError(err)
        })
    }


    useEffect(() => {
        if (!user.idCliente) {
            getData();
        }
    }, []);

    //cuando exista usuario pide campanias y filtra por ID de cliente
    useEffect(() => {
        setLoading(true);
        if (user.idCliente) {
            setLoading(false);
            if (!campanias.length) {
                getCampaignByClientIdFunc(user.idCliente);
            }
        }
    }, [user]);

    //filtra campanias al tipear
    useEffect(() => {
        filtrarCampsQuery(filterQuery);
    }, [filterQuery]);

    return (
        <div>
            <DashboardNav />

            {error && (
                <div className={classes.alert}>
                    <Typography component={"span"} style={{ fontSize: "16px" }}>
                        {error}
                    </Typography>
                    <Button
                        style={{ alignSelf: "center", marginTop: "16px" }}
                        bsStyle="primary"
                        id="btn-primary"
                        onClick={() => window.location.reload()}
                    >
                        Recargar
                    </Button>
                </div>
            )}

            {!error && state.search && !state.param && (
                <SearchCampaing
                    filterQuery={filterQuery}
                    setFilterQuery={setFilterQuery}
                    campanias={fiteredCamps || campanias}
                    error={error}
                    loading={loading}
                />
            )}

            {state.param && !state.search && !state.form && <AddParameters />}
            {state.form === true && !state.param && !state.search && (
                <Form id={user.idCliente} />
            )}
        </div>
    );
};
export default BuscarCampaña;



// WEBPACK FOOTER //
// ./src/scenes/campaña/BuscarCampaña.js